import { useState } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { useRouter } from 'next/router'
import styles from '../../styles/Header.module.css'

const navItems = [
  { title: 'Főoldal', url: '/' },
  { title: 'Bemutató', url: '/Bemutato' },
  { title: 'Települések', url: '/Telepulesek' },
  { title: 'Önkormányzat', url: '/Onkormanyzat' },
  { title: 'Galéria', url: '/Galeria' },
]

export default function Header() {
  const router = useRouter()
  const [open, setOpen] = useState(false)

  return (
    <nav className={styles.nav}>
      <Link href="/" className={styles.navLogo}>
        <span className={styles.logoDot}>
          <Image src="/holmiapp2.svg" alt="" width={18} height={18} className={styles.logoIcon} />
        </span>
        HolmiApp
      </Link>

      <div className={`${styles.navLinks} ${open ? styles.navLinksOpen : ''}`}>
        {navItems.map((item) => (
          <Link
            key={item.url}
            href={item.url}
            className={`${styles.navLink} ${router.pathname === item.url ? styles.active : ''}`}
            onClick={() => setOpen(false)}
          >
            {item.title}
          </Link>
        ))}
        <Link href="/#download" className={styles.btnPrimary} onClick={() => setOpen(false)}>
          Letöltés
        </Link>
      </div>

      <button
        className={styles.burger}
        onClick={() => setOpen(!open)}
        aria-label="Menü"
        type="button"
      >
        <span className={`${styles.burgerLine} ${open ? styles.burgerOpen1 : ''}`} />
        <span className={`${styles.burgerLine} ${open ? styles.burgerOpen2 : ''}`} />
        <span className={`${styles.burgerLine} ${open ? styles.burgerOpen3 : ''}`} />
      </button>
    </nav>
  )
}